import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { Dashboard } from '@/app/shared/models';

@Module({
  namespaced: true,
  name: 'dashboard',
  store,
  dynamic: true
})
class DashboardStoreModule extends VuexModule {
  public dashboard: Dashboard|null = null;

  @Mutation
  public setDashboard(value: Dashboard|null): void {
    this.dashboard = value;
  }
}

export default getModule(DashboardStoreModule);
